import React, { useState } from "react";
import styles from "./LocationList.module.css";
import { usePreferences } from "hooks/usePrefrences";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const LocationList = ({
  locationCentre,
  updateLocationCentre,
  locationSearchMode = "My Country",
  onLocationSelect,
}) => {
  const { formatDate } = usePreferences();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  // Get status for a specific location
  const getLocationStatus = (locationId) => {
    const record = locationCentre.find(
      (location) => location.location_id == locationId,
    );
    return record?.status ?? 1;
  };

  // Toggle status between available and closed
  const toggleStatus = (location, e) => {
    e.stopPropagation();
    if (!location.loc_b_m_id) return;

    const currentStatus = location.status ?? 1;
    const newStatus = currentStatus === 1 ? 0 : 1;

    // Update the join record status
    const updatedLocation = locationCentre.find(
      (l) => location.loc_b_m_id == l.loc_b_m_id,
    );

    if (updatedLocation) {
      updatedLocation.status = newStatus;

      updateLocationCentre(updatedLocation);
    }
  };

  // Handle line click
  const handleLineClick = (location) => {
    if (location.status === 0) return;
    setSelectedLocation(location);
    setShowConfirmation(true);
  };

  // Handle confirmation OK
  const handleConfirmOk = () => {
    if (selectedLocation) {
      const status = getLocationStatus(selectedLocation.id);
      onLocationSelect(selectedLocation, status);
      setShowConfirmation(false);
      setSelectedLocation(null);
    }
  };

  // Handle confirmation Back
  const handleConfirmBack = () => {
    setShowConfirmation(false);
    setSelectedLocation(null);
  };

  // Format location display text
  const getLocationDisplay = (location) => {
    let display = `${location.town}, ${location.region}`;
    if (location.postcode) {
      display += `, ${location.postcode}`;
    }
    if (locationSearchMode.toLowerCase() === "global" && location.country) {
      display += `, ${location.country}`;
    }
    return display;
  };

  return (
    <div className={styles.container}>
      <div className={styles.listContainer}>
        {locationCentre.length === 0 && (
          <p className={styles.notFound}>No location found</p>
        )}
        {locationCentre.map((location) => {
          const status = location.status ?? 1;
          const verifiedDate = location.verified_date;
          const buttonText =
            status === 0
              ? "Closed"
              : verifiedDate
                ? formatDate(verifiedDate)
                : "Available";
          const isClosed = status === 0;

          return (
            <div
              key={location.id}
              className={`${styles.rowCard} ${isClosed ? styles.disabled : ""}`}
              onClick={() => handleLineClick(location)}
            >
              <div className={styles.locationInfo}>
                <span className={styles.val}>
                  {getLocationDisplay(location)}
                </span>
              </div>

              <div className={styles.spacer} />

              <div className={styles.statusInfo}>
                <span
                  className={`${styles.val} ${isClosed ? styles.closed : ""}`}
                >
                  {buttonText}
                </span>
              </div>

              {!isClosed && (
                <button
                  className={`${styles.statusButton} ${styles.closed}`}
                  onClick={(e) => toggleStatus(location, e)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && selectedLocation && (
        <div className={styles.modalOverlay} onClick={handleConfirmBack}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className={styles.modalTitle}>Confirm Location</h3>
            <p className={styles.modalText}>
              You have used this location in {selectedLocation.town},{" "}
              {selectedLocation.region}?
            </p>
            <div className={styles.modalButtons}>
              <button
                className={`${styles.modalButton} ${styles.backButton}`}
                onClick={handleConfirmBack}
              >
                Back
              </button>
              <button
                className={`${styles.modalButton} ${styles.okButton}`}
                onClick={handleConfirmOk}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationList;
